module.exports = __webpack_public_path__ + "img/20220327_190410.5d22c9cc.jpg";